import { updatePromotionByField} from '@/api/promotion'
import moment from 'moment';

export default {
    components: {
    },
    props: {
        showForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    data () {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            loading: false,
            rules: {
                bid: [ { required: true, message: '请填写出价', trigger: 'change' }],
                roi_goal: [ { required: true, message: '请填写roi出价', trigger: 'change' }],
            },
            title: '',
        }
    },
    created () {
        this.title = '修改出价'
        if (this.model.field == 'roi_goal') {
           this.title = '修改roi出价'
        } 
    },
    computed: {
        actType() {
            return this.model.id ? '修改' : '添加'
        }
    },
    mounted () {
        console.log('进入',this.model)
    },
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            });
        },
        storeOrUpdate() {
            this.loading = true

            // const data = {
            //     advertiser_id: this.model.advertiser_id,
            //     id: this.model.promotion_id,
            //     field: 'bid',
            //     value: this.model.bid
            // }

            const data = {
                advertiser_id: this.model.advertiser_id,
                id: this.model.promotion_id,
                field: this.model.field,
                value: this.model[this.model.field],
                promotion: this.model.promotion
            }


            updatePromotionByField(data).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('修改成功')
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message);
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showForm', false)
        },
        moment,
    }
}
